interface TaggedCampaign {
    'account_id': number;
    'campaign_id': string;
    'sublevel_id': string | null;
    platform: string;
}

interface UpdateTagGroupAPIConfigParams {
    clientId: number;
    groupId: number;
    isFbTaggedLevelAdset: boolean;
    name: string;
    platform: string;
    taggedCampaigns: Array<TaggedCampaign>;
}

export const createAPIConfigForUpdateTagGroup = ({
    platform,
    clientId,
    groupId,
    isFbTaggedLevelAdset,
    name,
    taggedCampaigns,
}: UpdateTagGroupAPIConfigParams) => ({
    url: '/api/tag-group',
    method: 'PUT',
    params: {
        client_id: clientId,
        platform,
    },
    data: {
        client_id: clientId,
        group_id: groupId,
        is_fb_tagged_level_adset: isFbTaggedLevelAdset,
        name,
        tagged_campaign: taggedCampaigns,
    },
});
